var _classCallCheck = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var FormulaError = require('../formulas/error');

var _require = require('../formulas/helpers'),
    FormulaHelpers = _require.FormulaHelpers,
    Types = _require.Types,
    Address = _require.Address;

var _require2 = require('../formulas/operators'),
    Prefix = _require2.Prefix,
    Postfix = _require2.Postfix,
    Infix = _require2.Infix,
    Operators = _require2.Operators;

var Collection = require('./type/collection');

var MAX_ROW = 1048576,
    MAX_COLUMN = 16384;

var Utils = /*#__PURE__*/function () {
  "use strict";

  function Utils(context) {
    _classCallCheck(this, Utils);

    this.context = context;
  }

  _createClass(Utils, [{
    key: "columnNameToNumber",
    value: function columnNameToNumber(columnName) {
      return Address.columnNameToNumber(columnName);
    }
    /**
     * Parse the cell address only.
     * @param {string} cellAddress
     * @return {{ref: {col: number, address: string, row: number}}}
     */

  }, {
    key: "parseCellAddress",
    value: function parseCellAddress(cellAddress) {
      var res = cellAddress.match(/([$]?)([A-Za-z]{1,3})([$]?)([1-9][0-9]*)/); // console.log('parseCellAddress', cellAddress);

      return {
        ref: {
          address: res[0],
          col: this.columnNameToNumber(res[2]),
          row: +res[4]
        }
      };
    }
  }, {
    key: "parseRow",
    value: function parseRow(row) {
      var rowNum = +row;
      if (!Number.isInteger(rowNum)) throw Error('Row number must be integer.');
      return {
        ref: {
          col: undefined,
          row: +row
        }
      };
    }
  }, {
    key: "parseCol",
    value: function parseCol(col) {
      return {
        ref: {
          col: this.columnNameToNumber(col),
          row: undefined
        }
      };
    }
  }, {
    key: "parseColRange",
    value: function parseColRange(col1, col2) {
      // const res = colRange.match(/([$]?)([A-Za-z]{1,3}):([$]?)([A-Za-z]{1,4})/);
      col1 = this.columnNameToNumber(col1);
      col2 = this.columnNameToNumber(col2);
      return {
        ref: {
          from: {
            col: Math.min(col1, col2),
            row: null
          },
          to: {
            col: Math.max(col1, col2),
            row: null
          }
        }
      };
    }
  }, {
    key: "parseRowRange",
    value: function parseRowRange(row1, row2) {
      // const res = rowRange.match(/([$]?)([1-9][0-9]*):([$]?)([1-9][0-9]*)/);
      return {
        ref: {
          from: {
            col: null,
            row: Math.min(row1, row2)
          },
          to: {
            col: null,
            row: Math.max(row1, row2)
          }
        }
      };
    }
    /**
     * Apply + or - unary prefix.
     * @param {Array.<string>} prefixes
     * @param {*} value
     * @return {*}
     */

  }, {
    key: "applyPrefix",
    value: function applyPrefix(prefixes, value) {
      // console.log('applyPrefix', prefixes, value);
      var _this$extractRefValue = this.extractRefValue(value),
          val = _this$extractRefValue.val,
          isArray = _this$extractRefValue.isArray;

      if (this.isFormulaError(val)) return val;
      return Prefix.unaryOp(prefixes, val, isArray);
    }
  }, {
    key: "applyPostfix",
    value: function applyPostfix(value, postfix) {
      // console.log('applyPostfix', value, postfix);
      var _this$extractRefValue2 = this.extractRefValue(value),
          val = _this$extractRefValue2.val,
          isArray = _this$extractRefValue2.isArray;

      if (this.isFormulaError(val)) return val;
      return Postfix.percentOp(val, postfix, isArray);
    }
  }, {
    key: "applyInfix",
    value: function applyInfix(value1, infix, value2) {
      var res1 = this.extractRefValue(value1);
      var val1 = res1.val,
          isArray1 = res1.isArray;
      var res2 = this.extractRefValue(value2);
      var val2 = res2.val,
          isArray2 = res2.isArray;
      if (this.isFormulaError(val1)) return val1;
      if (this.isFormulaError(val2)) return val2;
      if (Operators.compareOp.includes(infix)) return Infix.compareOp(val1, infix, val2, isArray1, isArray2);else if (Operators.concatOp.includes(infix)) return Infix.concatOp(val1, infix, val2, isArray1, isArray2);else if (Operators.mathOp.includes(infix)) return Infix.mathOp(val1, infix, val2, isArray1, isArray2);else throw new Error("Unrecognized infix: ".concat(infix));
    }
  }, {
    key: "applyIntersect",
    value: function applyIntersect(refs) {
      var _this = this;

      // console.log('applyIntersect', refs);
      if (this.isFormulaError(refs[0])) return refs[0];
      if (!refs[0].ref) throw Error("Expecting a reference, but got ".concat(refs[0], ".")); // a intersection will keep track of references, value won't be retrieved here.

      var maxRow, maxCol, minRow, minCol, sheet, res; // index start from 1
      // first time setup

      var ref = refs.shift().ref;
      sheet = ref.sheet;

      if (!ref.from) {
        // check whole row/col reference
        if (ref.row === undefined || ref.col === undefined) {
          throw Error('Cannot intersect the whole row or column.');
        } // cell ref


        maxRow = minRow = ref.row;
        maxCol = minCol = ref.col;
      } else {
        // range ref
        // update
        maxRow = Math.max(ref.from.row, ref.to.row);
        minRow = Math.min(ref.from.row, ref.to.row);
        maxCol = Math.max(ref.from.col, ref.to.col);
        minCol = Math.min(ref.from.col, ref.to.col);
      }

      var err;
      refs.forEach(function (ref) {
        if (_this.isFormulaError(ref)) return ref;
        ref = ref.ref;
        if (!ref) throw Error("Expecting a reference, but got ".concat(ref, "."));

        if (!ref.from) {
          if (ref.row === undefined || ref.col === undefined) {
            throw Error('Cannot intersect the whole row or column.');
          } // cell ref


          if (ref.row > maxRow || ref.row < minRow || ref.col > maxCol || ref.col < minCol || sheet !== ref.sheet) {
            err = FormulaError.NULL;
          }

          maxRow = minRow = ref.row;
          maxCol = minCol = ref.col;
        } else {
          // range ref
          var refMaxRow = Math.max(ref.from.row, ref.to.row);
          var refMinRow = Math.min(ref.from.row, ref.to.row);
          var refMaxCol = Math.max(ref.from.col, ref.to.col);
          var refMinCol = Math.min(ref.from.col, ref.to.col);

          if (refMinRow > maxRow || refMaxRow < minRow || refMinCol > maxCol || refMaxCol < minCol || sheet !== ref.sheet) {
            err = FormulaError.NULL;
          } // update


          maxRow = Math.min(maxRow, refMaxRow);
          minRow = Math.max(minRow, refMinRow);
          maxCol = Math.min(maxCol, refMaxCol);
          minCol = Math.max(minCol, refMinCol);
        }
      });
      if (err) return err; // check if the ref can be reduced to cell reference

      if (maxRow === minRow && maxCol === minCol) {
        res = {
          ref: {
            sheet: sheet,
            row: maxRow,
            col: maxCol
          }
        };
      } else {
        res = {
          ref: {
            sheet: sheet,
            from: {
              row: minRow,
              col: minCol
            },
            to: {
              row: maxRow,
              col: maxCol
            }
          }
        };
      }

      if (!res.ref.sheet) delete res.ref.sheet;
      return res;
    }
  }, {
    key: "applyUnion",
    value: function applyUnion(refs) {
      var collection = new Collection();

      for (var i = 0; i < refs.length; i++) {
        if (this.isFormulaError(refs[i])) return refs[i];
        collection.add(this.extractRefValue(refs[i]).val, refs[i]);
      } // console.log('applyUnion', unions);


      return collection;
    }
    /**
     * Apply multiple references, e.g. A1:B3:C8:A:1:.....
     * @param refs
     // * @return {{ref: {from: {col: number, row: number}, to: {col: number, row: number}}}}
     */

  }, {
    key: "applyRange",
    value: function applyRange(refs) {
      var _this2 = this;

      var res,
          maxRow = -1,
          maxCol = -1,
          minRow = MAX_ROW + 1,
          minCol = MAX_COLUMN + 1;
      refs.forEach(function (ref) {
        if (_this2.isFormulaError(ref)) return ref; // row ref is saved as number, parse the number to row ref here

        if (typeof ref === 'number') {
          ref = _this2.parseRow(ref);
        }

        ref = ref.ref; // check whole row/col reference

        if (ref.row === undefined) {
          minRow = 1;
          maxRow = MAX_ROW;
        }

        if (ref.col === undefined) {
          minCol = 1;
          maxCol = MAX_COLUMN;
        }

        if (ref.row > maxRow) maxRow = ref.row;
        if (ref.row < minRow) minRow = ref.row;
        if (ref.col > maxCol) maxCol = ref.col;
        if (ref.col < minCol) minCol = ref.col;
      });

      if (maxRow === minRow && maxCol === minCol) {
        res = {
          ref: {
            row: maxRow,
            col: maxCol
          }
        };
      } else {
        res = {
          ref: {
            from: {
              row: minRow,
              col: minCol
            },
            to: {
              row: maxRow,
              col: maxCol
            }
          }
        };
      }

      return res;
    }
    /**
     * Throw away the refs, and retrieve the value.
     * @return {{val: *, isArray: boolean}}
     */

  }, {
    key: "extractRefValue",
    value: function extractRefValue(obj) {
      var res = obj,
          isArray = false;
      if (Array.isArray(res)) isArray = true;

      if (obj.ref) {
        // can be number or array
        return {
          val: this.context.retrieveRef(obj),
          isArray: isArray
        };
      }

      return {
        val: res,
        isArray: isArray
      };
    }
    /**
     *
     * @param array
     * @return {Array}
     */

  }, {
    key: "toArray",
    value: function toArray(array) {
      // TODO: check if array is valid
      // console.log('toArray', array);
      return array;
    }
    /**
     * @param {string} number
     * @return {number}
     */

  }, {
    key: "toNumber",
    value: function toNumber(number) {
      return Number(number);
    }
    /**
     * @param {string} string
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString(string) {
      return string.substring(1, string.length - 1).replace(/""/g, '"');
    }
    /**
     * @param {string} bool
     * @return {boolean}
     */

  }, {
    key: "toBoolean",
    value: function toBoolean(bool) {
      return bool === 'TRUE';
    }
    /**
     * Parse an error.
     * @param {string} error
     * @return {string}
     */

  }, {
    key: "toError",
    value: function toError(error) {
      return new FormulaError(error.toUpperCase());
    }
  }, {
    key: "isFormulaError",
    value: function isFormulaError(obj) {
      return obj instanceof FormulaError;
    }
  }]);

  return Utils;
}();

module.exports = Utils;